import React from "react";

export interface IAdminLocationAlertsListRowColumnProps {
  isHeader?: boolean;
  handleSort?: (field: string) => void;
  sortField: string;
  headerText: string;
  itemText?: string;
  currentSortField?: string;
  currentSortDirection?: string;
  children?: React.ReactNode;
}

export const AdminLocationAlertsListRowColumn = ({
  isHeader,
  handleSort,
  sortField,
  headerText,
  itemText,
  currentSortField,
  currentSortDirection,
  children,
}: IAdminLocationAlertsListRowColumnProps) => {
  return (
    <div
      className={`${sortField}-column ${sortField}${
        isHeader ? "-header" : "-item"
      }`}
    >
      {isHeader ? (
        !!handleSort ? (
          <button
            className="btn header-btn header-text"
            onClick={() => handleSort && handleSort(sortField)}
          >
            <span>{headerText}</span>
            {currentSortField === sortField &&
              currentSortDirection === "asc" && <span>↑</span>}
            {currentSortField === sortField &&
              currentSortDirection === "desc" && <span>↓</span>}
          </button>
        ) : (
          <span className="header-text">{headerText}</span>
        )
      ) : (
        <>
          {itemText && <span>{itemText}</span>}
          {children}
        </>
      )}
    </div>
  );
};
